export default __webpack_public_path__ + "static/media/mode-2040.86093317.svg";